import ExternalLink from 'components/UI/ExternalLink'
import { Flex } from 'theme-ui'
import DownloadForIos from 'images/download-for-ios.png'
import { ReactElement } from 'react'

export default function IosDownloadOptions(): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        width: '100%',
        alignItems: ['center', 'center', 'flex-start'],
      }}
    >
      <ExternalLink href="/install/mobile/ios">
        <img
          src={DownloadForIos}
          alt=""
          sx={{
            width: ['19.7rem', '15.9rem', '16.2rem'],
            height: ['6.2rem', '5.2rem', '5.4rem'],
          }}
        />
      </ExternalLink>
    </Flex>
  )
}
